/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { EditableComponent, ResponsiveGrid } from '@adobe/aem-react-editable-components';
import { Image, Media } from '@marriott/mi-ui-library';
import clsx from 'clsx';
import { CommitmentsSectionProps } from '../CommitmentIcons/CommitmentIcons.types';
import { StyledStatistics } from './Statistics.styles';

const StatisticsSection: React.FC<CommitmentsSectionProps> = (props: CommitmentsSectionProps) => {
  const { eyebrow, title, commitmentsListItems, componentId, styleclass, isInEditor, cqItems, itemPath, pagePath } =
    props;

  const imageContainer = () => {
    return (
      <ResponsiveGrid
        key={`${itemPath}/media-container`}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        pagePath={pagePath}
        itemPath={`${itemPath}/media-container`}
        columnCount="12"
        gridClassNames={''}
        config={{
          isEmpty: () => true,
          resourceType: 'mi-aem-martech/components/container',
        }}
        isInEditor={isInEditor}
      />
    );
  };

  const mediaComponent = (containerName: string, jsonData: any) => {
    // eslint-disable-next-line no-prototype-builtins
    if (jsonData?.hasOwnProperty(containerName)) {
      const container = jsonData[containerName];
      const containerItems = container[':items'];
      for (const itemKey in containerItems) {
        // eslint-disable-next-line no-prototype-builtins
        if (containerItems?.hasOwnProperty(itemKey)) {
          const item = containerItems[itemKey];

          return <Media {...item} />;
        } else {
          return null;
        }
      }
    } else {
      return null;
    }
    return null;
  };

  return (
    <StyledStatistics
      className={clsx(`${styleclass ? styleclass : 'lt-stats lt-unicef-stats'} lt-text ${componentId}`)}
    >
      <div className="container p-lg-0">
        <div className="content-wrapper row justify-content-center">
          <div className="img-wrapper col-12">
            {isInEditor && imageContainer()}
            {!isInEditor && mediaComponent('media-container', cqItems)}
          </div>
          <span className="lt-kicker-2">{eyebrow}</span>
          <h3 className="lt-title-3">{title}</h3>
          <div className="row lt-stats-wrapper">
            {commitmentsListItems?.map((item, index) => (
              <div className="col-6 col-lg-3" key={`stats-${index}`}>
                <div className="lt-stat">
                  <Image
                    defaultImageURL={item.image?.assetPath}
                    renditions={item.image?.renditions}
                    dynamic={item.image?.dynamic}
                    altText={item.imgAltText}
                    loading="eager"
                  />
                  <div className="lt-stat-inner">
                    <strong>{item.heading}</strong>
                    <p className="pb-3">{item.text}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </StyledStatistics>
  );
};

export const StatisticsConfig = {
  emptyLabel: 'Statistics',
  isEmpty: () => true,
  resourceType: 'mi-aem-martech/components/lovetravels/statistics',
};

export const LTStatistics = (props: CommitmentsSectionProps) => {
  return (
    <div data-testid="statistics" data-component-name="o-prearrival-lovetravels-stats">
      <EditableComponent config={StatisticsConfig} {...props}>
        <StatisticsSection {...props} />
      </EditableComponent>
    </div>
  );
};
